import React, { FC, useState } from 'react';
import { Box } from '@mui/material';

import { Chip } from '../Chip/Chip';
import Accordion from '../Accordion/Accordion';

import { accordionStyle } from './styles';

interface TagItem {
  id: string;
  name: string;
  icon?: string | null;
  color?: string;
  borderColor?: string;
  isPinned?: boolean;
}

interface TagsSectionProps {
  tags?: TagItem[];
  v2?: boolean;
}

export const TagsSection: FC<TagsSectionProps> = ({ tags = [], v2 }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  if (tags.length === 0) {
    return null;
  }

  return (
    <Accordion
      title="Tags"
      expanded={isExpanded}
      onChange={() => setIsExpanded(!isExpanded)}
      accordionStyle={accordionStyle}
      i18nKeyTitle="meals:dishDetails.tags"
    >
      <Box
        display="flex"
        alignItems="flex-start"
        alignContent="flex-start"
        gap="8px"
        alignSelf="stretch"
        flexWrap="wrap"
      >
        {tags.map((tag) => (
          <Chip
            key={tag.id}
            label={tag.name}
            variant="outlined"
            color="primary"
            size="medium"
            sx={{
              backgroundColor: v2 ? 'success.lightBg' : 'secondary.light',
              borderColor: v2 ? 'success.border' : 'secondary.dark',
            }}
          />
        ))}
      </Box>
    </Accordion>
  );
};

export default TagsSection;
